import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { transactionStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import { useMediaQuery } from 'react-responsive';
import MimaOptionMenu from '../../components/OptionMenu/';
import constant from '../../utils/constant';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { MimaText, Searchbar } from '../../components';

const Income = ({
	setOpenTagModal,
	setViewMoreIncome,
	transactions,
	setFilteredTransactions,
	filteredTransactions,
}) => {
	const isBelow600 = useMediaQuery({
		query: '(max-width: 600px)',
	});

	const [showList, setShowList] = useState(false);
	const [tableList, setTableList] = useState({
		key: constant.FLOW_TYPE.All,
		value: 'Type',
	});

	const data = [
		{
			key: constant.FLOW_TYPE.All,
			value: 'All',
		},
		{
			key: constant.FLOW_TYPE.Income,
			value: 'Income',
		},
		{
			key: constant.FLOW_TYPE.Untagged,
			value: 'Untagged',
		},
		{
			key: constant.FLOW_TYPE.Refund,
			value: 'Refund',
		},
		{
			key: constant.FLOW_TYPE.Funding,
			value: 'Wallet Funding',
		},
		{
			key: constant.FLOW_TYPE.Loan,
			value: 'Loan',
		},
		{
			key: constant.FLOW_TYPE.Investment,
			value: 'Investment',
		},
		{
			key: constant.FLOW_TYPE.Gifts,
			value: 'Gifts And Donations',
		},
		{
			key: constant.FLOW_TYPE.Assets,
			value: 'Sales Of Business Properties',
		},
	];

	const allIncome = useMemo(() => {
		const allIncome = transactions.filter(item => {
			return item.type === 'INFLOW';
		});
		return allIncome;
	}, [transactions]);

	const tableData = useMemo(() => {
		const tableData = allIncome.filter(inflow => {
			if (tableList.key === constant.FLOW_TYPE.All) {
				return true; // Show all inflows
			} else {
				return inflow.inflowType === tableList.key;
			}
		});
		return tableData;
	}, [allIncome, tableList]);

	return (
		<>
			<div className="searchInMiddle">
				<div className="searchInMiddle_filter">
					<div
						className={styles.tableButton}
						onClick={() => {
							setShowList(!showList);
						}}>
						{tableList.value}
						<span className={showList && styles.tableButton_active}>
							<MdKeyboardArrowDown size="20" />
						</span>
					</div>
					{showList && (
						<>
							{data.map((x, i) => (
								<div
									className={styles.dropDown}
									onClick={() => {
										setTableList(x);
										// setTableDetails(x.value)
										setShowList(false);
									}}
									key={i}>
									{x.value}
								</div>
							))}
						</>
					)}
				</div>
				<div className="searchInMiddle_search">
					<Searchbar
						placeholder="Search Transactions"
						variant="wide"
						input={tableData}
						loading={false}
						output={setFilteredTransactions}
						handleFilter={(item, searchQuery) => {
							return (
								item?.customer?.fullname
									?.toLowerCase()
									?.includes(searchQuery) ||
								item?.category?.toLowerCase()?.includes(searchQuery) ||
								item?.narration?.toLowerCase()?.includes(searchQuery) ||
								item?.inflowType?.toLowerCase()?.includes(searchQuery)
							);
						}}
					/>
				</div>
			</div>

			<div className="whiteTable">
				<>
					<table>
						<thead className={styles.tableHead}>
							<tr>
								<th> Created Date </th>
								<th> Narration</th>
								{!isBelow600 && <th> Amount Charged </th>}
								<th> Amount Received </th>
								{!isBelow600 && <th> Paid Date </th>}
								{!isBelow600 && <th> Balance </th>}
								{!isBelow600 && <th> Tag Type </th>}
								{!isBelow600 && <th> Action </th>}
							</tr>
						</thead>
						{filteredTransactions.length === 0 ? (
							<tbody className={styles.noRecord}>
								<MimaText variant="subtitleBold" mt={5} mb={5}>
									No Record Found
								</MimaText>
							</tbody>
						) : (
							<tbody>
								{filteredTransactions.map((transaction, index) => (
									<tr
										key={index}
										style={{
											backgroundColor:
												transaction.inflowType ===
													constant.FLOW_TYPE.Untagged &&
												transaction.status !== 'VOID' &&
												'var(--color-light-red)',
										}}>
										<td>
											{moment(transaction.createdAt).format('DD-MM-YYYY hh:mm')}{' '}
										</td>
										<td>
											{transaction.narration
												? transaction.narration
												: transaction.customer
													? transaction.customer?.fullname
													: transaction?.orders.length > 1
														? `Payment for ${transaction.orders[0].item} and ${transaction.orders.length - 1} item(s)`
														: `Payment for ${transaction.orders[0]?.item}`}
										</td>
										{!isBelow600 && (
											<td>
												{' '}
												{amountFormatter(transaction.currencyCode).format(
													transaction.transactionAmount || 0
												)}{' '}
											</td>
										)}
										<td>
											{amountFormatter(transaction.currencyCode).format(
												transaction.amountPaid || 0
											)}
										</td>
										{!isBelow600 && (
											<td>
												{moment(
													transaction.paidDate || transaction.createdAt
												).format('DD-MM-YYYY hh:mm')}{' '}
											</td>
										)}
										{!isBelow600 && (
											<td>
												{' '}
												{amountFormatter(transaction.currencyCode).format(
													transaction.balanceAmount || 0
												)}
											</td>
										)}
										{!isBelow600 && (
											<td
												style={{
													color:
														transaction.inflowType ===
															constant.FLOW_TYPE.Untagged &&
														transaction.status !== 'VOID' &&
														'var(--color-error)',
												}}>
												{transaction?.inflowType}
											</td>
										)}
										<td>
											<MimaOptionMenu
												options={[
													transaction.inflowType === constant.FLOW_TYPE.Untagged
														? {
																value: 'Tag Transaction',
																label: 'Tag Transaction',
															}
														: null,
													transaction.status !== 'VOID'
														? {
																value: 'Update Status',
																label: 'Update Status',
															}
														: null,
													{
														value: 'View More',
														label: 'View More',
													},
												]}
												onOptionSelected={option => {
													if (option.value === 'Tag Transaction') {
														setOpenTagModal(true);
														transactionStore.setSelectedIncome(transaction);
													} else if (option.value === 'View More') {
														transactionStore.setSelectedIncome(transaction);
														setViewMoreIncome(true);
													}
												}}
											/>
										</td>
									</tr>
								))}
							</tbody>
						)}
					</table>
				</>
			</div>
		</>
	);
};

export default Income;
